<template>
  <header class="layout_header">
    <slot></slot>
  </header>
</template>
<script>
export default {
  name: 'layout-header'
}
</script>
<style lang="scss" scoped>
  .layout_header {
    display: flex;
    width: 100%;
    height: 50px;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/layout-header.vue